import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    baseUrl: String,
    guardia: Boolean
  }
  static targets = ['form']

  download(event) {
    event.preventDefault();

    const searchController = this.findSearchController();
    if (!searchController) {
      console.error('No se encontró el controlador de búsqueda');
      alert('Error: no se pudo obtener los filtros actuales');
      return;
    }

    this.populateForm(searchController);
    this.formTarget.submit();
  }

  findSearchController() {
    const controllerName = this.guardiaValue ? 'search-pacientes-guardia' : 'search-pacientes';
    const searchElement = document.querySelector(`[data-controller*="${controllerName}"]`);

    if (searchElement) {
      try {
        return this.application.getControllerForElementAndIdentifier(searchElement, controllerName);
      } catch (e) {
        console.error('No se encontró el controlador', e);
      }
    }
    return null;
  }

  populateForm(searchController) {
    this.formTarget.querySelectorAll('input[type="hidden"]').forEach(input => input.remove());

    if (this.guardiaValue) {
      this.addHiddenField('guardia', 'true');
      this.addHiddenFieldIfPresent('q_guardia', searchController.searchInputTarget?.value);
      this.addHiddenFieldIfPresent('all_guardia', searchController.allGuardiaCheckboxTarget?.checked);
      this.addHiddenFieldIfPresent('obra_social_guardia', searchController.obraSocialTarget?.value);
      this.addHiddenFieldIfPresent('desde_guardia', searchController.desdeTarget?.value);
      this.addHiddenFieldIfPresent('hasta_guardia', searchController.hastaTarget?.value);
    } else {
      this.addHiddenFieldIfPresent('q', searchController.searchInputTarget?.value);
      this.addHiddenFieldIfPresent('all', searchController.allCheckboxTarget?.checked);
      this.addHiddenFieldIfPresent('sector', searchController.sectorTarget?.value);
      this.addHiddenFieldIfPresent('obra_social', searchController.obraSocialTarget?.value);
      this.addHiddenFieldIfPresent('tipo', searchController.tipoTarget?.value);
      this.addHiddenFieldIfPresent('desde', searchController.desdeTarget?.value);
      this.addHiddenFieldIfPresent('hasta', searchController.hastaTarget?.value);
    }
  }

  addHiddenField(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    this.formTarget.appendChild(input);
  }

  addHiddenFieldIfPresent(name, value) {
    if (value && value !== '' && value !== 'Sector' && value !== 'Obra social' && value !== 'Tipo') {
      this.addHiddenField(name, typeof value === 'boolean' ? 'true' : value);
    }
  }
}

